var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoGrocery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 700,
    height: 740,
    viewBox: "0 0 700 740",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M649 10.0384C649 10.0384 574.845 7.84103 545.25 36.705C516.797 64.449 505.042 85.649 505.042 143.372H9L83.375 400.143C83.5617 400.532 83.9015 400.904 84.1042 401.288C96.6055 436.344 129.284 461.593 168.271 463.059C168.431 463.129 169 463.372 169 463.372H515.667V473.997C515.667 473.997 515.708 490.059 505.042 511.393C494.375 532.726 489.063 543.372 446.396 543.372H99.7292C46.3958 543.372 46.3958 623.372 99.7292 623.372H163.687H169H430.354H435.667H441.083C505.083 623.372 553 586.018 569 548.684C585 511.351 585.042 479.413 585.042 479.413V463.372V143.372C585.042 115.446 597.235 90.0384 622.333 90.0384H651.708C673.799 90.0384 691.708 72.129 691.708 50.0384C691.708 27.9477 673.799 10.0384 651.708 10.0384H649ZM435.667 623.372C403.667 623.372 382.333 644.705 382.333 676.705C382.333 708.705 403.667 730.038 435.667 730.038C467.667 730.038 489 708.705 489 676.705C489 644.705 467.667 623.372 435.667 623.372ZM169 623.372C137 623.372 115.667 644.705 115.667 676.705C115.667 708.705 137 730.038 169 730.038C201 730.038 222.333 708.705 222.333 676.705C222.333 644.705 201 623.372 169 623.372Z",
    fill: "#062134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGrocery);
export default __webpack_public_path__ + "static/media/ico_grocery.1482ae2815588480a3c8648ffcbeec9e.svg";
export { ForwardRef as ReactComponent };